import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { PrimeNGConfig, MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-upload-wbs',
  standalone:false,
  templateUrl: './upload-wbs.component.html'
})
export class UploadWbsComponent implements  OnInit {
  RFPForm: FormGroup;
  uploadedFiles:any;
  allDmsFiles:any[]=[];
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() step: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  aipData=[]
  payload:any;

  constructor(private fb: FormBuilder, private config: PrimeNGConfig, private messageService: MessageService, private api: ApiService,
    private uploadService: UploadService, private route: ActivatedRoute) {
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
    });
 
    this.getAIPDocs()
  }

    toggleSection(section: string) {
      this.expandedSections[section] = !this.expandedSections[section];
    }
    expandedSections: { [key: string]: boolean } =
    {
     uploads: true,
     fileUpload: false,
    };



  getAIPDocs() {
    this.aipData = [];
    const sub = this.api
      .getAPI(`/idex/upload/wbs/?proposal_step=${this.stepDetails.id}`).subscribe(res=>{
       this.aipData = res;
      
      });
  }

  onFileUpload(event: any) {
    const file = event.target.files[0];
    console.log(file);
    if (file) {
      this.uploadedFiles = file;
      const formData = new FormData();
      formData.append('proposal_step', this.stepDetails.id);
      formData.append('document', file);
      if(this.aipData[0]?.id){
        this.api.putAPI(`/idex/upload/wbs/${this.aipData[0]?.id}/`, formData).subscribe((res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'File Uploaded',
            detail: `File uploaded successfully`,
          });
          this.getAIPDocs();
        });
      }else{
        this.api.postAPI(`/idex/upload/wbs/`, formData).subscribe((res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'File Uploaded',
            detail: `File uploaded successfully`,
          });
          this.getAIPDocs();
        });
      }
    };   
  }

 
}
